<template>
  <div ref="container" class="w-full">
    <ProductRecommendations
      v-if="selectedToken"
      :token="selectedToken"
      :title="$t(`recommendations.title.${props.blok.recommendationType}`)"
      :center-content="false"
    />
  </div>
  <LastSeenProductsRecommendations v-if="!isTypeLastSeen" />
</template>

<script setup lang="ts">
import type { SbRecommendations } from '~/cms/storyblok/types/storyblok.gen'
import ProductRecommendations from '~/components/product/ProductRecommendations.vue'
import {
  OdoscopeRecommendationsToken,
  RecommendationTypes,
} from '#layers/base/constants/recommendations'
import LastSeenProductsRecommendations from '#layers/base/components/product/LastSeenProductsRecommendations.vue'

const props = defineProps({
  blok: {
    type: Object as PropType<SbRecommendations>,
    default: () => {},
  },
})

const recommendationType = props.blok.recommendationType.toUpperCase()
const selectedToken = ref<OdoscopeRecommendationsToken>()
const isTypeLastSeen = recommendationType !== RecommendationTypes.LAST_SEEN

if (isTypeLastSeen && recommendationType in OdoscopeRecommendationsToken) {
  selectedToken.value =
    OdoscopeRecommendationsToken[
      recommendationType as keyof typeof OdoscopeRecommendationsToken
    ]
}
</script>
